// removed by extract-text-webpack-plugin
module.exports = {"container":"container__3UoVB","content":"content__1gSPA","collapser":"collapser__3uIEV","picture":"picture__3EIgA","info":"info__127UQ","title":"title__qi01c","details":"details__acYuI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeaturedProject/styles.scss
// module id = 243
// module chunks = 0